import React from 'react';

export default () => (
  <div className="footer">
    <div className="summary">
      <div className="logo">
        <img src={process.env.PUBLIC_URL + '/images/colorful_logo.png'} alt="logo" />
      </div>
      <div className="information basic-info">
        <div className="title">
          公司概况
        </div>
        <div className="links">
          <a href="/information#cooperators">陕西恒富源林业有限公司</a>
          <a href="/information#cooperative">战略合作单位</a>
          <a href="/information#summary">公司规模</a>
          <a href="/information#research-status">研究中心</a>
        </div>
        <div className="links">
          <a href="/information#cooperators">陕西秦山核桃专业合作社</a>
          <a href="/information#slogan">公司理念</a>
          <a href="/information#patent">专利和特色产品</a>
          <a href="/information#researchers">研究骨干</a>
        </div>
      </div>
      <div className="information projects">
        <div className="title">
          项目情况
        </div>
        <div className="links">
          <a href="/projects?project_id=1">药用植物及经济作物新型苗孵化基地及推广种植</a>
          <a href="/projects?project_id=2">镇安秦岭山区5000亩树莓基地建设</a>
          <a href="/projects?project_id=3">商洛市镇安县1000亩七叶树基地建设</a>
          <a href="/projects?project_id=4">镇安县板栗种植及深加工产业化</a>
        </div>
      </div>
    </div>
    <div className="contact">
      <span>联系我们</span>
      <span className="phone">
        <i className="icon icon-footer-phone"></i>
        029-86103367
      </span>
      <span className="address">
        <i className="icon icon-footer-location"></i>
        陕西，镇安，中小企业孵化园8号；销售公司:西安赛高国际321001室。
      </span>
    </div>
    <div className="copy-right">
      <span>Copyright © 2009–2015 奕诚生物 <a href="http://www.beian.miit.gov.cn/" target="_blank">陕ICP备15002419号-1</a></span>
      <script type="text/javascript" src="http://wljg.snaic.gov.cn/scripts/businessLicense.js?id=402881c858f32de60158f61846db006c"></script>
    </div>
  </div>
);